import component from './AutosuggestDataProvider';

export default component;
